<div>
  <div class="row justify-content-between align-items-end">
    <div class="col-auto form-group">
      <button class="btn btn-primary btn-small" (click)="onNewClaimClicked()">
        <i class="fas fa-money-check"></i>
        {{ 'creditClaims.submitnewClaim' | cxTranslate }}
      </button>
    </div>
    @if (rebateClaimsResults?.results?.length) {
      <div class="col col-sm-auto form-group">
        <app-custom-select
          [title]="'shared.sortBy' | cxTranslate"
          (changeValue)="sortChange($event)"
          [clearable]="true"
          [options]="options"
          [placeHolder]="'shared.select' | cxTranslate"
        ></app-custom-select>
      </div>
    }
  </div>
</div>

@if (rebateClaimsResults?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="rebateClaimCode"
    override="RebateClaimsHistoryRow"
    [rows]="rebateClaimsResults.results"
    [pagination]="rebateClaimsResults.pagination"
    (changePagination)="pageChange($event + 1)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (!showLoaderOnPagination) {
    <app-custom-error [errorMessage]="'shared.noClaims' | cxTranslate"></app-custom-error>
  }
}


@if (showLoaderOnStartupOrWhenNoData) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
